function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Immutable from 'immutable';
import ActionTypes from '../../ActionsTypes';
var initialState = Immutable.fromJS({});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var countryID = {};
  var plotID = {};
  var plots = {};
  var key = '';
  var value = '';
  var currentData = [];
  var temp0;
  var temp1;

  switch (action.type) {
    case ActionTypes.SAVE_COUNTRY_DATA:
      if (state && !state.ni) {
        // Fix me, instead of -state.ni- send the country code as payload so you can check the current variable country
        action.payload.data.plots.map(function (a) {
          var metadata = {
            id: a.name,
            title: a.title,
            description: a.description,
            url: a.dataUrl
          };
          plots[a.name] = {
            metadata: metadata
          };
        });
        return _objectSpread({}, state, _defineProperty({}, action.payload.id, {
          description: action.payload.data,
          plots: plots
        }));
      }

      return state;

    case ActionTypes.SAVE_PLOT_DATA:
      countryID = action.payload.id.split('/')[0];
      plotID = action.payload.id.split('/')[1];

      if (state[countryID]) {
        if (state[countryID].plots[plotID] && action.payload.data) {
          var plot = state[countryID].plots[plotID];
          var data = action.payload.data;
          currentData = action.payload.data;

          if (plotID == 'gen_type_bar_yearly') {
            var datax = {
              MW: [],
              MWh: []
            };
            data.map(function (a) {
              var category1 = [];
              var category2 = [];
              a.values.map(function (b) {
                category1.push({
                  x: b.datetime,
                  y: b.mw
                });
                category2.push({
                  x: b.datetime,
                  y: b.mwh
                });
              });
              datax.MWh.push(_defineProperty({}, a.id, category1));
              datax.MW.push(_defineProperty({}, a.id, category2));
            });
            data = datax;
            currentData = {
              id: 'MW',
              values: datax.MW
            };
          }

          if (plotID == 'energy_per_unit') {
            var category1 = [];
            var category2 = [];
            data.map(function (a) {
              category1.push({
                x: a.datetime,
                y: a.gdp_per_mwh
              });
              category2.push({
                x: a.datetime,
                y: a.kwh_per_capita
              });
            });
            data = {
              kwh_per_capita: {
                tag: 'kWh/capita',
                values: category2
              },
              gdp_per_mwh: {
                tag: 'GDP/MWh',
                values: category1
              }
            };
            currentData = {
              id: 'gdp_per_mwh',
              values: {
                tag: 'GDP/MWh',
                values: category1
              }
            };
          }

          plots = state[countryID].plots;
          return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, plot, {
              data: data,
              init: true,
              controls: _objectSpread({}, plot.controls, {
                dataShown: {
                  checkbox: {},
                  dropdown: {}
                },
                range: {
                  total: {},
                  current: {},
                  update: {}
                }
              }),
              currentState: {
                loading: false,
                data: currentData
              }
            })))
          })));
        }

        return state;
      }

      return state;

    case ActionTypes.SET_CURRENT_DATA:
      countryID = action.payload.countryID;
      plotID = action.payload.plotID;

      if (state[countryID]) {
        if (state[countryID].plots[plotID]) {
          var _plot = state[countryID].plots[plotID];
          plots = state[countryID].plots;
          currentData = _plot.data[action.payload.key];
          return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot, {
              currentState: _objectSpread({}, _plot.currentState, {
                data: {
                  id: action.payload.key,
                  values: currentData
                }
              })
            })))
          })));
        }
      }

      return state;

    case ActionTypes.SAVE_PLOT_META_DATA:
      countryID = action.payload.id.split('/')[0];
      plotID = action.payload.id.split('/')[1];

      if (state[countryID]) {
        if (state[countryID].plots[plotID]) {
          var _plot2 = state[countryID].plots[plotID];
          plots = state[countryID].plots;

          if (plotID === 'gen_map_time') {
            temp0 = {
              available: ['month']
            };
          }

          if (plotID === 'capacity_plant_resource') {
            temp1 = {
              available: ['year']
            };
          }

          var time_resolution = action.payload.data && action.payload.data.time_resolution ? action.payload.data.time_resolution : temp0 || temp1;
          var grouped_types = action.payload.data && action.payload.data.grouped_types ? action.payload.data.grouped_types : undefined;
          var data_types = action.payload.data && action.payload.data.data_types ? action.payload.data.data_types : undefined;
          var type = action.payload.data && action.payload.data.type ? action.payload.data.type : undefined;
          var unit = action.payload.data && action.payload.data.unit ? action.payload.data.unit : undefined;
          if (!_plot2.controls) return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot2, {
              controls: _objectSpread({}, _plot2.controls, {
                time_resolution: time_resolution,
                data_types: data_types,
                grouped_types: grouped_types,
                dataShown: {
                  checkbox: {},
                  dropdown: {}
                },
                range: {
                  total: {},
                  current: {},
                  update: {}
                }
              }),
              metadata: _objectSpread({}, _plot2.metadata, {
                type: type,
                unit: unit
              })
            })))
          })));
          return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot2, {
              controls: _objectSpread({}, _plot2.controls, {
                time_resolution: time_resolution,
                data_types: data_types,
                grouped_types: grouped_types
              }),
              metadata: _objectSpread({}, _plot2.metadata, {
                type: type,
                unit: unit
              })
            })))
          })));
        }
      }

      return state;

    case ActionTypes.TOGGLE_LOAD_PLOT_DATA:
      countryID = action.payload.countryID;
      plotID = action.payload.plotID;

      if (state[countryID]) {
        if (state[countryID].plots[plotID]) {
          var _plot3 = state[countryID].plots[plotID];
          plots = state[countryID].plots;
          return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot3, {
              currentState: _objectSpread({}, _plot3.currentState, {
                loading: true
              })
            })))
          })));
        }

        return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
          plots: _objectSpread({}, plots, _defineProperty({}, plotID, {
            currentState: {
              loading: true
            }
          }))
        })));
      }

      return state;

    case ActionTypes.UPDATE_DATE_RANGE:
      countryID = action.payload.countryID;
      plotID = action.payload.plotID;

      if (state[countryID]) {
        if (state[countryID].plots[plotID]) {
          var _plot4 = state[countryID].plots[plotID];
          plots = state[countryID].plots;

          if (_plot4.controls && _plot4.controls.range) {
            return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
              plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot4, {
                controls: _objectSpread({}, _plot4.controls, {
                  range: _objectSpread({}, _plot4.controls.range, {
                    update: action.payload.data
                  })
                })
              })))
            })));
          }

          return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot4, {
              controls: {
                range: {
                  update: action.payload.data
                }
              }
            })))
          })));
        }
      }

      return state;

    case ActionTypes.SET_CURRENT_DATE_RANGE:
      countryID = action.payload.countryID;
      plotID = action.payload.plotID;

      if (state[countryID]) {
        if (state[countryID].plots[plotID]) {
          var _plot5 = state[countryID].plots[plotID];
          plots = state[countryID].plots;

          if (_plot5.controls && _plot5.controls.range) {
            return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
              plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot5, {
                controls: _objectSpread({}, _plot5.controls, {
                  range: _objectSpread({}, _plot5.controls.range, {
                    current: action.payload.data
                  })
                })
              })))
            })));
          }

          return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot5, {
              controls: {
                range: {
                  current: action.payload.data
                }
              }
            })))
          })));
        }
      }

      return state;

    case ActionTypes.SET_TOTAL_DATE_RANGE:
      countryID = action.payload.countryID;
      plotID = action.payload.plotID;

      if (state[countryID]) {
        if (state[countryID].plots[plotID]) {
          var _plot6 = state[countryID].plots[plotID];
          plots = state[countryID].plots;

          if (_plot6.controls && _plot6.controls.range) {
            return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
              plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot6, {
                controls: _objectSpread({}, _plot6.controls, {
                  range: _objectSpread({}, _plot6.controls.range, {
                    total: action.payload.data,
                    current: action.payload.data
                  })
                })
              })))
            })));
          }

          return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot6, {
              controls: _objectSpread({}, _plot6.controls, {
                range: {
                  total: action.payload.data,
                  current: action.payload.data
                }
              })
            })))
          })));
        }
      }

      return state;

    case ActionTypes.TOGGLE_CHECKBOX:
      countryID = action.payload.countryID;
      plotID = action.payload.plotID;

      if (state[countryID]) {
        if (state[countryID].plots[plotID]) {
          var _plot7 = state[countryID].plots[plotID];
          var id = action.payload.input;
          var checkbox = _plot7.controls.dataShown.checkbox;
          plots = state[countryID].plots;

          if (checkbox[action.payload.input]) {
            return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
              plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot7, {
                controls: _objectSpread({}, _plot7.controls, {
                  dataShown: _objectSpread({}, _plot7.controls.dataShown, {
                    checkbox: _objectSpread({}, checkbox, _defineProperty({}, id, {
                      show: !checkbox[id].show
                    }))
                  })
                })
              })))
            })));
          }

          return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot7, {
              controls: _objectSpread({}, _plot7.controls, {
                dataShown: _objectSpread({}, _plot7.controls.dataShown, {
                  checkbox: _objectSpread({}, checkbox, _defineProperty({}, id, {
                    show: false
                  }))
                })
              })
            })))
          })));
        }
      }

      return state;

    case ActionTypes.UNCHECK_CHECKBOX:
      countryID = action.payload.countryID;
      plotID = action.payload.plotID;

      if (state[countryID]) {
        if (state[countryID].plots[plotID]) {
          var _plot8 = state[countryID].plots[plotID];
          key = action.payload.key;
          var _checkbox = _plot8.controls.dataShown.checkbox;
          plots = state[countryID].plots;

          if (_checkbox[action.payload.input]) {
            return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
              plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot8, {
                controls: _objectSpread({}, _plot8.controls, {
                  dataShown: _objectSpread({}, _plot8.controls.dataShown, {
                    checkbox: _objectSpread({}, _checkbox, _defineProperty({}, key, {
                      show: false
                    }))
                  })
                })
              })))
            })));
          }

          return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot8, {
              controls: _objectSpread({}, _plot8.controls, {
                dataShown: _objectSpread({}, _plot8.controls.dataShown, {
                  checkbox: _objectSpread({}, _checkbox, _defineProperty({}, key, {
                    show: false
                  }))
                })
              })
            })))
          })));
        }
      }

      return state;

    case ActionTypes.TOGGLE_ITEMS:
      countryID = action.payload.countryID;
      plotID = action.payload.plotID;

      if (state[countryID]) {
        if (state[countryID].plots[plotID]) {
          var _plot9 = state[countryID].plots[plotID];
          var _id = action.payload.id;
          var dropdown = _plot9.controls.dataShown.dropdown;
          plots = state[countryID].plots;

          if (dropdown[action.payload.id]) {
            return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
              plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot9, {
                controls: _objectSpread({}, _plot9.controls, {
                  dataShown: _objectSpread({}, _plot9.controls.dataShown, {
                    dropdown: _objectSpread({}, dropdown, _defineProperty({}, _id, {
                      show: !dropdown[_id].show
                    }))
                  })
                })
              })))
            })));
          }

          return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot9, {
              controls: _objectSpread({}, _plot9.controls, {
                dataShown: _objectSpread({}, _plot9.controls.dataShown, {
                  dropdown: _objectSpread({}, dropdown, _defineProperty({}, _id, {
                    show: true
                  }))
                })
              })
            })))
          })));
        }
      }

      return state;

    case ActionTypes.ADD_ENTRY:
      countryID = action.payload.countryID;
      plotID = action.payload.plotID;
      key = action.payload.key;
      value = action.payload.value;

      if (state[countryID]) {
        if (state[countryID].plots[plotID]) {
          var _plot10 = state[countryID].plots[plotID];
          plots = state[countryID].plots;

          if (_plot10.controls && _plot10.controls.range) {
            return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
              plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot10, {
                currentState: _objectSpread({}, _plot10.currentState, _defineProperty({}, key, value))
              })))
            })));
          }

          return _objectSpread({}, state, _defineProperty({}, countryID, _objectSpread({}, state[countryID], {
            plots: _objectSpread({}, plots, _defineProperty({}, plotID, _objectSpread({}, _plot10, {
              controls: {
                range: {
                  total: action.payload.data
                }
              }
            })))
          })));
        }
      }

      return state;

    default:
      return state;
  }
});